/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';

import { DialogService } from '@hmax-order/frontend/dialog';

@Injectable()
export class HmaxErrorHandler implements ErrorHandler {
  private _dialog = inject(DialogService);
  private _ngZone = inject(NgZone);

  /**
   * Extrair mensagem de erro dos diferentes tipos de erro possíveis
   */
  static getErrorMessage(error: any): string {
    let message: any = '';
    const isHttpErrorResponse = error instanceof HttpErrorResponse;

    if (isHttpErrorResponse) {
      message = error?.error?.message ?? error.message;
      const isMessageArray = Array.isArray(message);
      message = isMessageArray ? message.join('\n') : message;
      message = this.extractHttpErrorResponse(message);
    } else {
      message = error.promise?.error?.message ?? error.rejection?.error?.message ?? error.message ?? error;
      message = this.extractErrorMessage(message);
      message = this.getInvalidValue(message);
    }

    message = HmaxErrorHandler.getConnectionFailMessage(message);

    if (HmaxErrorHandler.supressError(error, message)) {
      return '';
    }

    message = this.getHttpFailureResponseMessage(message);

    return message;
  }

  private static supressError(error: any, message: string) {
    const invalidToken = message === 'Invalid token';
    const invalidSession = message === 'Invalid session';
    return invalidToken || invalidSession;
  }

  private static extractHttpErrorResponse(input: string): any | null {
    if (!input) {
      return;
    }
    const pattern = /Uncaught \(in promise\): HttpErrorResponse: (.*)/;
    const match = input.match(pattern);

    if (match && match.length > 1) {
      const errorString = match[1];

      try {
        return JSON.parse(errorString);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        return input;
      }
    }

    return input;
  }

  private static extractErrorMessage(message: string): string {
    const regex = /"message":"([^"]+): 0 Unknown Error/;
    const match = message.match(regex);

    if (match?.length && match.length > 1) {
      return match[1];
    }

    return message;
  }

  private static getInvalidValue(message: string): string {
    const lowerMessage = message.toLowerCase();
    const match = lowerMessage.includes('got invalid value');

    if (match) return 'invalid-value';

    return message;
  }

  private static getHttpFailureResponseMessage(message: string) {
    if (!message) {
      return;
    }
    const unkownError = message.includes('Unknown Error');
    const failureResponse = message.substring(0, 21) === 'Http failure response';

    if (failureResponse || unkownError) {
      return 'error-connection';
    }
    return message;
  }

  private static getConnectionFailMessage(message: string) {
    // ## tratar mensagem: Kind: I/O error: Foi forçado o cancelamento de uma conexão existente pelo host remoto
    const isConnectionFail = message?.includes('error 10054');
    return isConnectionFail ? 'error-connection' : message;
  }

  handleError(error: any) {
    const message = HmaxErrorHandler.getErrorMessage(error);
    const isAngularError = this.isAngularError(message);
    const showDialog = message && message !== '' && !isAngularError;

    if (showDialog && message) {
      // Adiar abertura do diálogo para o próximo ciclo de detecção de mudanças do Angular
      // e evitar de o diálogo abrir sem mostrar todo o seu conteúdo
      this._ngZone.run(() => {
        this._dialog.error(message);
      });
    } else {
      console.error(error);
    }
  }

  private isAngularError(message: string): boolean {
    const regex = /NG\d+/;
    return regex.test(message);
  }
}
